/**
 * 27/10/2026 — one part of the paste review folded into one row (user: "make it intuitive
 * minimaliste … smooth"): the Automation's own SectionToggle — icon, title, count, a one-line
 * summary, Show / Hide — opening smoothly (Collapse). Folded by default, so the window reads as
 * its status card and the details are one click away; its actions show once it is open.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode, useState } from 'react';
import type { LucideIcon } from 'lucide-react';

import { Collapse } from '@/features/drop-generator/components/timeline/section/Collapse';
import { SectionToggle } from '@/features/drop-generator/components/timeline/section/SectionToggle';

interface Props {
  icon: LucideIcon;
  title: string;
  count?: number | string;
  summary: string;
  /** Compact buttons at the row's end, shown while open — e.g. Copy all · Keep all. */
  actions?: ReactNode;
  children: ReactNode;
}

export const ReviewFold: FC<Props> = ({ icon, title, count, summary, actions, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <section aria-label={title} className="min-w-0">
      <SectionToggle icon={icon} title={title} badge={count} summary={summary} open={open} onToggle={() => setOpen((v) => !v)} actions={open ? actions : undefined} />
      <Collapse open={open}>
        <div className="flex min-w-0 flex-col divide-y divide-border/50 border-t border-border/50 bg-muted/10 pb-1">{children}</div>
      </Collapse>
    </section>
  );
};
